The input parameter for the `updateCandidateProcessHistoryItem` mutation.
